import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#F9FAFC' : '',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'start',
    color: '#000000',
    borderRadius: '0',
    height: '100%',
  }));

  export default Item;